import config from '../../../config';

export const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;
export const BUILD_VERSION_META_NAME = 'cogneed-build-version';

export function buildIndexUrl() {
  const url = new URL(window.location.href);
  url.hash = '';
  url.search = '';
  url.pathname = url.pathname.replace(/\/index\.html$/, '') || '/';
  url.searchParams.set('ts', Date.now().toString());
  return url.toString();
}

export const NIGHTLY_STORAGE_KEY = 'cogneed-nightly-channel';

export function isNightlyChannelEnabled(): boolean {
  return config.FeatureFlags.NightlyChannelEnabled === 'true';
}

export function isOnNightly(): boolean {
  return /\/nightly(?:\/(?:index\.html)?)?$/.test(window.location.pathname);
}

export function getNightlyUrl(): string {
  const basePath = window.location.pathname
    .replace(/\/index\.html$/, '')
    .replace(/\/?$/, '/');
  return `${window.location.origin}${basePath}nightly`;
}

export function getStableUrl(): string {
  const basePath = window.location.pathname
    .replace(/\/index\.html$/, '')
    .replace(/\/nightly\/?$/, '/');
  return `${window.location.origin}${basePath}`;
}

export function applyChannelRedirect(): boolean {
  const { pathname } = window.location;

  if (pathname.endsWith('/index.html')) {
    const url = new URL(window.location.href);
    url.pathname = pathname.slice(0, -'/index.html'.length);
    window.location.replace(url.toString());
    return true;
  }

  const hasOAuthCode = new URLSearchParams(window.location.search).has('code');
  if (hasOAuthCode) return false;

  const nightlyEnabled = isNightlyChannelEnabled();
  const wantsNightly = localStorage.getItem(NIGHTLY_STORAGE_KEY) !== null;
  const onNightly = isOnNightly();

  if (!nightlyEnabled) {
    if (!onNightly) return false;

    const url = new URL(window.location.href);
    url.pathname = new URL(getStableUrl()).pathname;
    window.location.replace(url.toString());
    return true;
  }

  if (wantsNightly && !onNightly) {
    const url = new URL(window.location.href);
    url.pathname = new URL(getNightlyUrl()).pathname;
    window.location.replace(url.toString());
    return true;
  }
  if (!wantsNightly && onNightly) {
    const url = new URL(window.location.href);
    url.pathname = new URL(getStableUrl()).pathname;
    window.location.replace(url.toString());
    return true;
  }
  return false;
}

export async function fetchPublishedVersion() {
  const response = await fetch(buildIndexUrl(), {
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Unable to fetch index.html: ${response.status}`);
  }

  const html = await response.text();
  const document = new DOMParser().parseFromString(html, 'text/html');
  return document
    .querySelector(`meta[name="${BUILD_VERSION_META_NAME}"]`)
    ?.getAttribute('content')
    ?.trim() || null;
}

export function readCurrentDocumentVersion() {
  return document
    .querySelector(`meta[name="${BUILD_VERSION_META_NAME}"]`)
    ?.getAttribute('content')
    ?.trim() || null;
}

export function refreshCurrentDocument() {
  const url = new URL(window.location.href);
  url.searchParams.set('refresh', Date.now().toString());
  window.location.assign(url.toString());
}
